"use client"

import React, { createContext, useContext, type ReactNode } from "react"
import type { ExplorerController } from "@/hooks/use-explorer-controller"

const ExplorerContext = createContext<ExplorerController | null>(null)

/** Shares the explorer's live state with its blades (filters, fields, records) */
export function ExplorerProvider({ controller, children }: { controller: ExplorerController; children: ReactNode }) {
  return <ExplorerContext.Provider value={controller}>{children}</ExplorerContext.Provider>
}

export function useExplorerContext(): ExplorerController {
  const controller = useContext(ExplorerContext)
  if (!controller) throw new Error("useExplorerContext must be used inside ExplorerProvider")
  return controller
}
